import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { loadGameState, saveGameState } from "src/app/astrova/game-logic";

type AccessStep = "nickname" | "ship" | "ready";
type ShipId = "astrova" | "helios" | "nova";

interface ShipOption {
    id: ShipId;
    name: string;
    probeId: string;
    statLabel: string;
}

interface AccessProfile {
    nickname: string;
    shipId: ShipId;
    probeId: string;
    createdAt: string;
}

const ACCESS_PROFILE_STORAGE_KEY = "astrova.accessProfile.v1";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  width: 100%;
  min-height: 100%;
  color: #dff6ff;
  background: #08091a;
  font-family: "Press Start 2P", SUIT, monospace;
}

* {
  box-sizing: border-box;
}

h1,
h2,
p {
  margin: 0;
}

button,
input {
  font: inherit;
  letter-spacing: 0;
}

.access-shell {
  position: relative;
  display: grid;
  place-items: center;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  padding: 24px;
  background: radial-gradient(circle at 18% 16%, rgba(126, 207, 255, 0.12) 0 7%, transparent 8%), radial-gradient(circle at 82% 22%, rgba(255, 217, 102, 0.08) 0 6%, transparent 7%), linear-gradient(rgba(126, 207, 255, 0.028) 1px, transparent 1px), linear-gradient(90deg, rgba(126, 207, 255, 0.028) 1px, transparent 1px), #08091a;
  background-size: 100% 100%, 100% 100%, 28px 28px, 28px 28px, 100% 100%;
  image-rendering: pixelated;
}

.access-shell::before,
.access-shell::after {
  position: absolute;
  pointer-events: none;
  content: "";
}

.access-shell::before {
  inset: 0;
  background: repeating-linear-gradient(0deg, transparent 0 27px, rgba(126, 207, 255, 0.025) 27px 28px), repeating-linear-gradient(90deg, transparent 0 27px, rgba(126, 207, 255, 0.025) 27px 28px);
}

.access-shell::after {
  right: 7%;
  bottom: 9%;
  width: 180px;
  height: 180px;
  border: 2px solid rgba(126, 207, 255, 0.12);
  box-shadow: inset 0 0 0 14px rgba(126, 207, 255, 0.025), 0 0 38px rgba(126, 207, 255, 0.08);
  transform: rotate(18deg);
}

.space-stars,
.stars {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.stars {
  width: 2px;
  height: 2px;
  background: #f3fbff;
}

.stars-a {
  left: 42px;
  top: 36px;
  box-shadow: 74px 62px #7ecfff, 188px 24px #ffd966, 314px 134px #f3fbff, 478px 58px #7ecfff, 616px 188px #f3fbff, 784px 78px #ffd966, 966px 168px #7ecfff, 1130px 46px #f3fbff, 1262px 122px #ffd966, 130px 394px #f3fbff, 354px 520px #7ecfff, 592px 428px #ffd966, 814px 620px #f3fbff, 1064px 478px #7ecfff, 1244px 704px #f3fbff;
  animation: twinkleA 1.8s steps(2) infinite;
}

.stars-b {
  left: 12px;
  top: 118px;
  background: #7ecfff;
  box-shadow: 154px 42px #f3fbff, 278px 204px #7ecfff, 438px 112px #ffd966, 698px 258px #f3fbff, 900px 94px #7ecfff, 1174px 246px #ffd966, 98px 610px #7ecfff, 430px 686px #f3fbff, 712px 548px #ffd966, 1018px 702px #7ecfff;
  animation: twinkleB 2.3s steps(2) infinite;
}

.stars-c {
  left: 90px;
  top: 76px;
  width: 3px;
  height: 3px;
  background: #ffd966;
  box-shadow: 254px 52px #7ecfff, 520px 166px #f3fbff, 760px 24px #ffd966, 1004px 286px #7ecfff, 1320px 188px #f3fbff, 170px 726px #ffd966, 486px 636px #7ecfff, 884px 746px #f3fbff;
  animation: twinkleA 2.8s steps(2) infinite;
}

.access-card {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  gap: 22px;
  width: min(520px, 100vw - 32px);
  min-height: 590px;
  border: 2px solid #1a2030;
  padding: 24px;
  background: rgba(13, 21, 37, 0.96);
  box-shadow: inset 0 0 0 2px rgba(126, 207, 255, 0.06), 0 0 0 4px rgba(8, 9, 26, 0.9), 0 0 48px rgba(126, 207, 255, 0.16);
}

.access-card::before {
  position: absolute;
  inset: 10px;
  border: 1px solid rgba(126, 207, 255, 0.14);
  pointer-events: none;
  content: "";
}

.access-card-header,
.step-panel {
  position: relative;
  z-index: 1;
}

.access-card-header {
  display: grid;
  gap: 12px;
  text-align: center;
}

.access-kicker,
.eyebrow {
  color: #7ecfff;
  font-size: 9px;
  line-height: 1.4;
}

.access-card-header h1 {
  color: #ffd966;
  font-size: 34px;
  line-height: 1;
  text-shadow: 4px 4px 0 rgba(0, 0, 0, 0.42);
}

.step-track {
  display: grid;
  grid-template-columns: 26px minmax(0, 1fr) 26px minmax(0, 1fr) 26px;
  align-items: center;
  gap: 8px;
  width: min(260px, 100%);
  margin: 2px auto 0;
}

.step-dot {
  display: grid;
  place-items: center;
  width: 26px;
  height: 26px;
  border: 2px solid #263149;
  background: #050814;
  color: #6f86a6;
  font-size: 9px;
  line-height: 1;
}

.step-dot.is-active {
  border-color: #7ecfff;
  color: #08091a;
  background: #7ecfff;
  box-shadow: 0 0 16px rgba(126, 207, 255, 0.32);
}

.step-line {
  height: 2px;
  background: #263149;
}

.step-line.is-active {
  background: #7ecfff;
}

.step-panel {
  display: grid;
  align-content: start;
  gap: 22px;
  min-height: 0;
}

.step-copy {
  display: grid;
  gap: 12px;
  text-align: center;
}

.step-copy h2 {
  color: #eaf9ff;
  font-size: 21px;
  line-height: 1.45;
}

.step-copy p {
  color: #8fa5c4;
  font-size: 10px;
  line-height: 1.8;
}

.nickname-form {
  display: grid;
  gap: 12px;
  margin-top: 10px;
}

.nickname-form label {
  color: #7ecfff;
  font-size: 10px;
  line-height: 1;
}

.nickname-form input {
  width: 100%;
  height: 54px;
  border: 2px solid #263149;
  padding: 0 14px;
  outline: none;
  background: #050814;
  color: #ffd966;
  font-size: 13px;
  line-height: 1.2;
}

.nickname-form input::placeholder {
  color: #44536e;
}

.nickname-form input:focus {
  border-color: #7ecfff;
  box-shadow: inset 0 0 0 2px rgba(126, 207, 255, 0.08), 0 0 18px rgba(126, 207, 255, 0.18);
}

.error-message {
  min-height: 18px;
  color: #ff6b6b;
  font-size: 9px;
  line-height: 1.5;
}

.selected-ship-visual,
.ready-ship {
  position: relative;
  display: grid;
  place-items: center;
  height: 150px;
}

.selected-ship-visual::before,
.ready-ship::before {
  position: absolute;
  width: 190px;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(126, 207, 255, 0.42), transparent);
  content: "";
}

.ship-pixel {
  position: relative;
  width: 80px;
  height: 116px;
  image-rendering: pixelated;
  transform: rotate(45deg);
  filter: drop-shadow(8px 8px 0 rgba(0, 0, 0, 0.42)) drop-shadow(0 0 14px rgba(255, 105, 74, 0.22));
}

.ship-pixel::before,
.ship-pixel::after,
.ship-pixel span,
.ship-pixel i {
  position: absolute;
  display: block;
  content: "";
}

.ship-pixel::before {
  left: 30px;
  top: 0;
  width: 20px;
  height: 34px;
  background: #fff0a3;
  box-shadow: 0 8px #efd07a, 0 18px #b9774d, 0 34px #eef4ef, 0 44px #6e7580;
  clip-path: polygon(50% 0, 100% 22%, 100% 78%, 72% 100%, 28% 100%, 0 78%, 0 22%);
}

.ship-pixel::after {
  left: 23px;
  top: 32px;
  width: 34px;
  height: 76px;
  background: #b5322f;
  box-shadow: inset -8px 0 #7d1d22, inset 8px 0 #cf5b3f, 0 8px 0 #8f2024, 0 72px 0 #3f3037;
  clip-path: polygon(50% 0, 74% 12%, 100% 56%, 84% 100%, 16% 100%, 0 56%, 26% 12%);
}

.ship-pixel span:nth-child(1) {
  z-index: 4;
  left: 32px;
  top: 64px;
  width: 16px;
  height: 24px;
  background: #51c8c8;
  box-shadow: inset 0 0 0 4px #2a8f95, inset 6px 0 0 #93f0ee;
}

.ship-pixel span:nth-child(2),
.ship-pixel span:nth-child(3) {
  z-index: 1;
  top: 72px;
  width: 34px;
  height: 40px;
  background: #aa2d2d;
  box-shadow: 0 26px 0 #68181e;
}

.ship-pixel span:nth-child(2) {
  left: 2px;
  clip-path: polygon(100% 0, 100% 100%, 0 88%, 14% 62%, 54% 22%);
}

.ship-pixel span:nth-child(3) {
  right: 2px;
  clip-path: polygon(0 0, 46% 22%, 86% 62%, 100% 88%, 0 100%);
}

.ship-pixel i {
  z-index: 5;
  left: 31px;
  top: 104px;
  width: 18px;
  height: 18px;
  background: #fff1a4;
  box-shadow: -6px 10px #ffb65c, 6px 10px #ff704a, 0 18px #ffdf76;
  animation: flameBlink 0.28s steps(2) infinite;
}

.ship-helios .ship-pixel::after,
.ship-helios.mini-ship {
  background: #d35b2e;
}

.ship-helios .ship-pixel span:nth-child(1) {
  background: #7ecfff;
}

.ship-nova .ship-pixel::after,
.ship-nova.mini-ship {
  background: #4b69ff;
}

.ship-nova .ship-pixel span:nth-child(1) {
  background: #4aff8a;
}

.ship-options {
  display: grid;
  gap: 10px;
}

.ship-option {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  min-height: 58px;
  border: 2px solid #263149;
  padding: 10px 12px;
  color: #dff6ff;
  text-align: left;
  background: #080f1d;
  cursor: pointer;
}

.ship-option:hover,
.ship-option:focus-visible,
.ship-option.is-selected {
  border-color: #7ecfff;
  outline: none;
  box-shadow: inset 0 0 0 2px rgba(126, 207, 255, 0.08), 0 0 18px rgba(126, 207, 255, 0.16);
}

.ship-option.is-selected {
  background: rgba(126, 207, 255, 0.09);
}

.mini-ship {
  width: 24px;
  height: 34px;
  background: #b5322f;
  box-shadow: 8px 6px 0 #7d1d22, -8px 6px 0 #cf5b3f, 0 34px 0 #ffb65c;
  clip-path: polygon(50% 0, 88% 20%, 100% 72%, 78% 100%, 22% 100%, 0 72%, 12% 20%);
}

.ship-option strong {
  overflow: hidden;
  color: #eaf9ff;
  font-size: 11px;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ship-option small {
  color: #ffd966;
  font-size: 9px;
  line-height: 1;
}

.launch-summary {
  display: grid;
  gap: 10px;
}

.launch-summary div {
  display: grid;
  grid-template-columns: 84px minmax(0, 1fr);
  align-items: center;
  min-height: 46px;
  border: 2px solid #263149;
  padding: 10px 12px;
  background: #080f1d;
}

.launch-summary span {
  color: #7ecfff;
  font-size: 9px;
  line-height: 1;
}

.launch-summary strong {
  overflow: hidden;
  color: #ffd966;
  font-size: 10px;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.step-actions {
  display: grid;
  grid-template-columns: 1fr 1.4fr;
  gap: 10px;
  margin-top: 2px;
}

.primary-action,
.secondary-action {
  display: grid;
  place-items: center;
  min-height: 50px;
  border: 2px solid;
  padding: 0 14px;
  cursor: pointer;
}

.primary-action {
  border-color: #1e713e;
  background: #4aff8a;
  color: #06120b;
  box-shadow: 0 0 18px rgba(74, 255, 138, 0.2);
}

.primary-action:hover,
.primary-action:focus-visible {
  border-color: #ffd966;
  outline: none;
  background: #ffd966;
}

.secondary-action {
  border-color: #263149;
  background: #050814;
  color: #8fa5c4;
}

.secondary-action:hover,
.secondary-action:focus-visible {
  border-color: #7ecfff;
  color: #dff6ff;
  outline: none;
}

.launch-action {
  animation: launchPulse 1.2s steps(2) infinite;
}

@keyframes twinkleA {
  50% {
    opacity: 0.42;
  }
}
@keyframes twinkleB {
  50% {
    opacity: 0.28;
  }
}
@keyframes flameBlink {
  50% {
    height: 28px;
    transform: translateY(4px);
    box-shadow: -8px 14px #ff704a, 8px 14px #ffb65c, 0 24px #fff1a4;
  }
}
@keyframes launchPulse {
  50% {
    box-shadow: 0 0 0 2px rgba(74, 255, 138, 0.28), 0 0 28px rgba(74, 255, 138, 0.38);
  }
}
@media (max-width: 640px) {
  .access-shell {
    align-items: start;
    min-height: 100svh;
    overflow: auto;
    padding: 14px;
  }
  .access-card {
    width: 100%;
    min-height: calc(100svh - 28px);
    padding: 18px;
  }
  .access-card-header h1 {
    font-size: 26px;
  }
  .step-copy h2 {
    font-size: 17px;
  }
  .step-copy p {
    font-size: 9px;
  }
  .ship-option {
    grid-template-columns: 32px minmax(0, 1fr);
  }
  .ship-option small {
    grid-column: 2;
  }
  .launch-summary div {
    grid-template-columns: 72px minmax(0, 1fr);
  }
}`],
})
export class PageAccessComponent implements OnInit {
    public step: AccessStep = "nickname";
    public nickname = "";
    public selectedShipId: ShipId = "astrova";
    public errorMessage = "";

    public readonly ships: ShipOption[] = [
        {
            id: "astrova",
            name: "ASTROVA-1",
            probeId: "ASTROVA-1",
            statLabel: "BALANCED"
        },
        {
            id: "helios",
            name: "HELIOS-7",
            probeId: "HELIOS-7",
            statLabel: "ENGINE"
        },
        {
            id: "nova",
            name: "NOVA-3",
            probeId: "NOVA-3",
            statLabel: "SCAN"
        }
    ];

    constructor(@Inject( Router) private readonly router: Router) {}

    public ngOnInit(): void {
        if (this.hasAccessProfile()) {
            void this.router.navigateByUrl("/", { replaceUrl: true });
        }
    }

    public get currentStepIndex(): number {
        if (this.step === "nickname") return 0;
        if (this.step === "ship") return 1;
        return 2;
    }

    public get selectedShip(): ShipOption {
        return this.ships.find((ship) => ship.id === this.selectedShipId) || this.ships[0];
    }

    public trackById(_index: number, item: ShipOption): string {
        return item.id;
    }

    public continueFromNickname(event: Event): void {
        event.preventDefault();

        const normalized = this.normalizeNickname(this.nickname);
        if (normalized.length < 2) {
            this.errorMessage = "닉네임은 2자 이상 입력해주세요.";
            return;
        }

        this.nickname = normalized;
        this.errorMessage = "";
        this.step = "ship";
    }

    public selectShip(shipId: ShipId): void {
        this.selectedShipId = shipId;
        this.errorMessage = "";
    }

    public continueFromShip(): void {
        this.step = "ready";
    }

    public backToNickname(): void {
        this.errorMessage = "";
        this.step = "nickname";
    }

    public backToShip(): void {
        this.errorMessage = "";
        this.step = "ship";
    }

    public startGame(): void {
        const now = new Date();
        const ship = this.selectedShip;
        const profile: AccessProfile = {
            nickname: this.normalizeNickname(this.nickname),
            shipId: ship.id,
            probeId: ship.probeId,
            createdAt: now.toISOString()
        };

        try {
            localStorage.setItem(ACCESS_PROFILE_STORAGE_KEY, JSON.stringify(profile));
        } catch {
            // Access should continue even if local storage is unavailable.
        }

        const state = loadGameState(now);
        state.saveId = `pilot-${this.createProfileId(profile.nickname)}`;
        state.run.probe.probeId = profile.probeId;
        saveGameState(state, now);
        void this.router.navigateByUrl("/", { replaceUrl: true });
    }

    private normalizeNickname(value: string): string {
        return value.trim().replace(/\s+/g, " ").slice(0, 12);
    }

    private createProfileId(value: string): string {
        const normalized = value
            .toLowerCase()
            .replace(/[^a-z0-9가-힣]+/g, "-")
            .replace(/^-+|-+$/g, "");

        return normalized || "pilot";
    }

    private hasAccessProfile(): boolean {
        try {
            const raw = localStorage.getItem(ACCESS_PROFILE_STORAGE_KEY);
            if (!raw) return false;

            const profile = JSON.parse(raw) as Partial<AccessProfile>;
            return Boolean(profile.nickname && profile.shipId && profile.probeId);
        } catch {
            return false;
        }
    }
}

export default PageAccessComponent;